import { render, staticRenderFns } from "./admin.vue?vue&type=template&id=23b117e5&scoped=true"
import script from "./admin.vue?vue&type=script&lang=ts"
export * from "./admin.vue?vue&type=script&lang=ts"
import style0 from "./admin.vue?vue&type=style&index=0&id=23b117e5&prod&lang=less&scoped=true"
import style1 from "./admin.vue?vue&type=style&index=1&id=23b117e5&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b117e5",
  null
  
)

export default component.exports